import axios from 'axios'
import * as utils from './apiUtils'

export default {
  index(params) {
    return axios.get(utils.getApiUrl('/emergency_tels'), {
      params: params || {}
    })
  },
}
